




































import { TimelineSurveyResponses, TimelineSurveyResponsesKnowledgeableAnswers } from '@/controllers/models/TimelineSurveyResponses';
import UserInfoController from '@/controllers/UserInfo';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class TimelineSurveyForm extends Vue {
    questions = new TimelineSurveyResponses;
    submitting = false;
    error = '';

    get howLikelyOptions()
    {
        const res = [];
        res.push({ text: '0 (least likely)', value: 0 });
        for (let i = 1; i < 10; ++i) {
            res.push({ text: i.toString(), value: i });
        }
        res.push({ text: '10 (most likely)', value: 10 });
        return res;
    }

    get howKnowledgeable()
    {
        const res = [
            { text: 'Less Knowledgeable', value: TimelineSurveyResponsesKnowledgeableAnswers.Less },
            { text: 'Same', value: TimelineSurveyResponsesKnowledgeableAnswers.Same },
            { text: 'More Knowledgeable', value: TimelineSurveyResponsesKnowledgeableAnswers.More },
        ];
        return res;
    }

    get shouldDisableFields()
    {
        return this.submitting;
    }

    async submit()
    {
        this.error = '';
        if (!this.questions.howLikelyToRecommend)
        {
            this.error = "Please select an answer for how likely you are to recommend ClioVis.";
            return false;
        }
        
        if (!this.questions.howKnowledgeableOrConfident)
        {
            this.error = "Please select an answer for how knowledgeable/confident you feel.";
            return false;
        }

        this.submitting = true;
        try {
            if (!this.questions) return false;
            try {
                await UserInfoController.SetUserTimelineSurveyResponses(this.questions);
            }
            catch (err) {
                const resp = (err as any).response;
                return resp.data;
            }
            return true;
        }
        finally
        {
            this.submitting = false;
        }
    }
}
